import { Component } from '@angular/core';
import { ApiService } from '../../../api.service';

@Component({
  selector: 'app-admin-games',
  templateUrl: './admin-games.component.html',
  styleUrls: ['./admin-games.component.scss'],
})
export class AdminGamesComponent {
  constructor(public api: ApiService) {}

  columns = [
    {
      field: 'Id',
      title: 'Ref.',
      type: 'string',
      filter: true,
      sort: true,
    },
    {
      field: 'name',
      title: 'Nom',
      type: 'string',
      filter: true,
      sort: true,
    },
    {
      field: 'name_editor',
      title: 'Editeur',
      type: 'string',
      filter: true,
      sort: true,
    },
    {
      field: 'date',
      title: "Date d'ajout",
      type: 'date',
      filter: false,
      sort: true,
    },
    {
      field: 'out_date',
      title: 'Date de sortie',
      type: 'date',
      filter: false,
      sort: true,
    },
    {
      field: 'xx_Disponible_pour_la_vente',
      title: 'Dispo vente',
      type: 'checkbox',
      filter: false,
      sort: false,
      tooltip: 'Nécessaire pour affichage espace pro classique et GSS',
    },
    {
      field: 'force_outstock',
      title: 'Forcer rupture',
      type: 'checkbox',
      filter: false,
      sort: false,
      tooltip: 'Force rupture de stock',
    },
    {
      field: 'xx_Jeux_catalogue_GSS',
      title: 'Catalogue GSS',
      type: 'checkbox',
      filter: false,
      sort: false,
      tooltip: 'Si décoché absent espace pro GSS',
    },
    {
      field: 'xx_Jeux_catalogue_GBL',
      title: 'Catalogue GBL',
      type: 'checkbox',
      filter: false,
      sort: false,
    },
    {
      field: 'xx_Belux',
      title: 'Catalogue Belux',
      type: 'checkbox',
      filter: false,
      sort: false,
    },
    {
      field: 'on_top',
      title: 'Sel du moment',
      type: 'checkbox',
      filter: false,
      sort: true,
    },
    {
      field: 'on_top_gss',
      title: 'Sel du moment GSS',
      type: 'checkbox',
      filter: false,
      sort: true,
    },
  ];

  games: any;

  ngOnInit() {
    this.refresh();
  }

  refresh() {
    this.api.post('pro=getAllGames&adminOrder=true', {}).then((res: any) => {
      this.games = res.jeux.filter((item) => {
        for (let col of this.columns) {
          if (col.type == 'checkbox')
            item[col.field] = parseInt(item[col.field]);
        }
        return true;
      });
    });
  }

  update(row, field) {
    if (field.indexOf('xx_') === 0) {
      this.api
        .postWS('sql=update', {
          database: 'Item',
          data: { [field]: row[field] },
          where: "Id = '" + row.Id + "'",
        })
        .then((res: any) => {
          this.api.success('Modifications enregistrées');
        });
    } else {
      this.api
        .post('SPDO=update', {
          database: 'item',
          data: { [field]: row[field] },
          where: { id_item: row.id_item },
        })
        .then((res: any) => {
          this.api.success('Modifications enregistrées');
        });
    }
  }
}
